module.exports = __webpack_public_path__ + "fonts/-L14Jk06m6pUHB-5mXQQnYX0hVgzZQUfRDuZrPvH3D8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/-L14Jk06m6pUHB-5mXQQnYX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = 320
// module chunks = 0